import { useNavigate } from 'react-router-dom';
import { cn } from '@/lib/utils';
import logoDefault from '@/assets/logo-default.png';
import logoDark from '@/assets/logo-dark.png';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  onClick?: () => void;
  darkMode?: boolean;
}

const sizeClasses = {
  sm: 'h-8',
  md: 'h-10',
  lg: 'h-12',
};

export const Logo = ({ size = 'md', className, onClick, darkMode = false }: LogoProps) => {
  const navigate = useNavigate();
  
  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      navigate('/');
    }
  };

  return (
    <img
      src={darkMode ? logoDark : logoDefault}
      alt="Growth Lens - B2B Manufacturing Growth Assessment"
      className={cn(
        sizeClasses[size],
        'cursor-pointer',
        className
      )}
      onClick={handleClick}
    />
  );
};
